import { Component, OnInit } from '@angular/core';
import { EmailTrigger } from '../../enum/email.trigger';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EventsService } from '../../service/events.service';
import { NotificationService } from '../../service/notification.service';
import { Event } from '../../model/event';
import { EmailTemplatesEditDirective } from 'src/app/class/email-templates-edit';
import { SelectOption } from 'src/app/model/select.option';
import { EmailTemplateEditDialogComponent } from 'src/app/component/email-template-edit-dialog/email-template-edit-dialog.component';

@Component({
  selector: 'app-admin-default-email-templates',
  templateUrl: './admin-default-email-templates.component.html',
  styleUrls: ['./admin-default-email-templates.component.scss']
})
export class AdminDefaultEmailTemplatesComponent extends EmailTemplatesEditDirective implements OnInit {
  emailExists = false;

  /** Coluna única da tabela de gatilhos (cada linha = um item do antigo dropdown). */
  triggerColumns = ['name'];
  /** Texto do filtro (busca em chip no header). */
  search = '';

  constructor(
    protected fb: FormBuilder,
    protected translateService: TranslateService,
    protected eventsService: EventsService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) {
    super(false, fb, translateService, eventsService);
  }

  ngOnInit() {
    this.initComponent();
  }

  initComponent(): void {
    this.initForm();
  }

  updateSelectedEmailTemplate(): void {
    this.eventsService.editDefaultEmailTemplate(this.notificationEmail.trigger, this.notificationEmail)
      .subscribe(nf => {
        this.notificationService.notify('admin.email-template.email-updated');
        this.notificationEmail = nf;
      });
  }

  getEmailTemplate(trigger: EmailTrigger): void {
    this.getDefaultEmailTemplate(trigger);
  }

  /** Gatilho atualmente selecionado (id) — para destacar a linha na tabela. */
  get selectedTrigger(): any {
    return this.filterForm?.value?.emailTrigger;
  }

  /** Linhas filtradas pela busca (sobre o nome traduzido do gatilho). */
  get filteredTriggers(): SelectOption[] {
    const normalize = (v: any) =>
      (v || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    const term = normalize(this.search);
    if (!term) { return this.emailTriggers; }
    return this.emailTriggers.filter(t =>
      normalize(this.translateService.instant(t.value as string)).includes(term)
    );
  }

  /**
   * Clique numa linha: destaca o gatilho e abre a MESMA janela modal usada na
   * página "Modelos de e-mail" do TPC Chair (editor lado a lado com preview ao
   * vivo), porém em `defaultMode` — edita o template-base do gatilho (sem evento).
   */
  selectTrigger(trigger: SelectOption): void {
    this.filterForm.get('emailTrigger').setValue(trigger.id);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '900px';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.panelClass = 'email-template-edit-dialog-panel';
    dialogConfig.data = {
      event: null,
      trigger: trigger.id,
      triggerLabel: trigger.value,
      defaultMode: true
    };
    this.dialog.open(EmailTemplateEditDialogComponent, dialogConfig);
  }
}
